module.exports = __webpack_public_path__ + "banner03.jpg?622a01204206b0ba0dc16ae70e9399db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner03.jpg
// module id = 63
// module chunks = 0